import { useMemo } from "react";

export function useWidgetFilterDropdowns(dataVar, selectedDistrict, selectedMunicipality) {
  const data = useMemo(() => {
    return Array.isArray(dataVar) ? dataVar : [];
  }, [dataVar]);

  const uniqueDistricts = useMemo(() => {
    return Object.values(
      data.reduce((acc, item) => {
        if (!acc[item.districtMOT]) {
          acc[item.districtMOT] = item;
        }
        return acc;
      }, {})
    ).sort((a, b) => (a.districtMOT || "").localeCompare(b.districtMOT || ""));
  }, [data]);

  const uniqueMunicipalities = useMemo(() => {
    return Object.values(
      data
        .filter((item) => {
          const matchDistrict = !selectedDistrict || item.districtMOT === selectedDistrict.districtMOT;

          return matchDistrict;
        })
        .reduce((acc, item) => {
          if (!acc[item.municipalityName]) {
            acc[item.municipalityName] = item;
          }
          return acc;
        }, {})
    ).sort((a, b) => (a.municipalityName || "").localeCompare(b.municipalityName || ""));
  }, [selectedDistrict, data]);

  const uniqueTerminals = useMemo(() => {
    return Object.values(
      data
        .filter((item) => {
          const matchDistrict = !selectedDistrict || item.districtMOT === selectedDistrict.districtMOT;
          const matchMunicipality = !selectedMunicipality || item.municipalityName === selectedMunicipality.municipalityName;

          return matchDistrict && matchMunicipality;
        })
        .reduce((acc, item) => {
          if (!acc[item.terminalName]) {
            acc[item.terminalName] = item;
          }
          return acc;
        }, {})
    ).sort((a, b) => (a.terminalName || "").localeCompare(b.terminalName || ""));
  }, [selectedDistrict, selectedMunicipality, data]);

  return {
    uniqueDistricts,
    uniqueMunicipalities,
    uniqueTerminals,
  };
}
